//
//
//
//
//
//
//
//

export default {
  props: {
    mode: {
      type: String,
      default: ""
    },
    paraMatchDate: {
      type: String,
      default: ""
    },
    paraCompanyName: {
      type: String,
      default: ""
    }
  },
  data(){
    return{
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    }
  },
  methods: {
    fcTableToExcel(table){
      if (!table.nodeType) table = document.getElementById(table);
      var worksheetTitle = this.paraMatchDate + '_' + this.paraCompanyName.toUpperCase();
      var ctx = {worksheet: worksheetTitle || 'Worksheet', table: table.innerHTML}
      // window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      var link = document.createElement("a")
      link.download = this.mode + "_" +  worksheetTitle +  ".xls"
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
    }
  }
};
